import { Route, Routes } from 'react-router-dom-v5-compat'

import { SignUp } from './SignUp'

export const SignUpRoute = () => (
  <Routes>
    <Route index element={<SignUp />} />
  </Routes>
)
